import { GitBranch, LayoutDashboard, MessageSquare, Server, Cpu } from "lucide-react";

type Product = "flows" | "admin" | "chat" | "mcp-server" | "runtime";

interface ProductBadgeProps {
  product: Product;
}

/** Matches landing resource/card badge chrome: primary-dim surface + primary text. */
const badgeBase = "bg-primary-dim text-primary-text border-primary-border";

const products: Record<Product, { label: string; icon: React.ReactNode }> = {
  flows: {
    label: "Manage agents (Flows)",
    icon: <GitBranch size={12} />,
  },
  admin: {
    label: "Admin dashboard",
    icon: <LayoutDashboard size={12} />,
  },
  chat: {
    label: "Chat",
    icon: <MessageSquare size={12} />,
  },
  "mcp-server": {
    label: "Anter MCP Server",
    icon: <Server size={12} />,
  },
  runtime: {
    label: "Agent Runtime",
    icon: <Cpu size={12} />,
  },
};

export function ProductBadge({ product }: ProductBadgeProps) {
  const p = products[product];
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-md border mb-4 ${badgeBase}`}
    >
      {p.icon}
      {p.label}
    </span>
  );
}
